(() => {
  const root = window.Shopify?.routes?.root || '/';
  const q = (s, el = document) => el.querySelector(s);
  const all = (s, el = document) => [...el.querySelectorAll(s)];
  const status = message => { const node = q('#sp-status'); if (node) node.textContent = message; };
  let cartBusy = false;
  async function refreshCart() {
    const response = await fetch(`${root}cart.js`);
    if (!response.ok) throw new Error('Unable to refresh your bag. Please open the cart page.');
    const cart = await response.json();
    all('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const sectionsResponse = await fetch(`${root}?sections=cart-drawer`);
    if (!sectionsResponse.ok) throw new Error('Your bag changed. Open the cart page to review it.');
    const sections = await sectionsResponse.json();
    if (!sections['cart-drawer']) throw new Error('Open the cart page to review your bag.');
    const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    q('[data-cart-body]').replaceChildren(...q('[data-cart-body]', doc).childNodes);
  }
  document.addEventListener('click', async event => {
    const target = event.target.closest('button, [data-cart-open]');
    if (!target) return;
    const drawer = q('#CartDrawer');
    if (target.matches('[data-cart-open]')) { event.preventDefault(); drawer.showModal(); return; }
    if (target.matches('[data-cart-close]')) { drawer.close(); return; }
    if (target.matches('[data-sticky-buy]')) { const form = q('.sp-product-form'); form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' }); q('select', form)?.focus({ preventScroll: true }); }
    if (target.matches('[data-cart-remove]') && !cartBusy) {
      cartBusy = true; target.disabled = true; q('[data-cart-error]').textContent = '';
      try {
        const response = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: target.dataset.cartRemove, quantity: 0 }) });
        if (!response.ok) throw new Error('Unable to remove this item. Please try again.');
        await refreshCart(); status('Item removed from your bag.');
      } catch (error) { q('[data-cart-error]').textContent = error.message; }
      finally { cartBusy = false; target.disabled = false; q('[data-cart-close]')?.focus(); }
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.sp-product-form');
    if (!form) return;
    event.preventDefault();
    const button = q('[data-add-button]', form);
    if (button.disabled) return;
    button.disabled = true;
    const errorNode = q('[data-product-error]', form);
    errorNode.textContent = '';
    let added = false;
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this item. Please try again.');
      added = true; await refreshCart(); q('#CartDrawer').showModal(); status('Added to your bag.');
    } catch (error) { errorNode.textContent = added ? 'Added to your bag. Open the bag page to review your order.' : error.message; }
    finally { button.disabled = q('[data-variant-select]', form).selectedOptions[0].dataset.available !== 'true'; }
  });
  function initialize(scope = document) {
    all('[data-product-section]', scope).forEach(section => {
      if (section.dataset.initialized) return; section.dataset.initialized = 'true';
      const select = q('[data-variant-select]', section), plan = q('[data-plan-select]', section), price = q('[data-variant-price]', section), quantity = q('[name=quantity]', section);
      const variants = JSON.parse(q('[data-variant-data]', section).textContent);
      const updatePrice = () => { price.textContent = plan?.selectedOptions[0]?.dataset.price || select.selectedOptions[0].dataset.price; };
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0], variant = variants.find(v => String(v.id) === select.value);
        q('[data-add-button]', section).disabled = option.dataset.available !== 'true';
        q('[data-add-button]', section).textContent = option.dataset.available === 'true' ? 'Add to bag' : 'Sold out';
        quantity.min = variant.min; quantity.step = variant.increment; if (variant.max) quantity.max = variant.max; else quantity.removeAttribute('max'); quantity.value = variant.min;
        if (plan) {
          const previous = plan.value, oneTime = q('option[value=""]', plan)?.cloneNode(true);
          plan.replaceChildren(); if (oneTime) plan.append(oneTime);
          variant.plans.forEach(p => { const option = new Option(`${p.name} · ${p.price}`, p.id); option.dataset.price = p.price; plan.append(option); });
          if ([...plan.options].some(o => o.value === previous)) plan.value = previous;
        }
        if (option.dataset.image) { const img = q('.sp-gallery img', section); if (img) { img.src = option.dataset.image; img.removeAttribute('srcset'); } }
        updatePrice(); const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
      });
      plan?.addEventListener('change', updatePrice); updatePrice();
      const observer = new IntersectionObserver(entries => q('.sp-sticky-buy', section).toggleAttribute('data-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0)); observer.observe(q('.sp-product-form', section));
    });
    all('[data-tin-lab]', scope).forEach(lab => {
      if (lab.dataset.initialized) return; lab.dataset.initialized = 'true';
      let pick = q('[data-tin-pick]', lab), flipped = false;
      if (!pick) { q('[data-tin-flip]', lab).hidden = true; return; }
      const render = () => { const img = q('[data-tin-image]', lab); img.hidden = false; img.src = flipped ? pick.dataset.back : pick.dataset.front; img.alt = `${pick.dataset.title} ${flipped ? 'Supplement facts' : 'front'}`; q('[data-tin-flip]', lab).setAttribute('aria-pressed', String(flipped)); all('[data-tin-pick]', lab).forEach(button => button.setAttribute('aria-pressed', String(button === pick))); };
      render();
      all('[data-tin-pick]', lab).forEach(button => button.addEventListener('click', () => { pick = button; flipped = false; all('[data-tin-pick]', lab).forEach(b => b.setAttribute('aria-pressed', String(b === pick))); render(); }));
      q('[data-tin-flip]', lab).addEventListener('click', () => { flipped = !flipped; render(); });
    });
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mediaObserver = new IntersectionObserver(entries => entries.forEach(entry => { const video = entry.target; if (entry.isIntersecting && !reduced) video.play().catch(() => {}); else video.pause(); }), { rootMargin: '100px' });
    all('[data-loop]', scope).forEach(video => mediaObserver.observe(video));
    const chapterObserver = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { const clock = q('[data-day-clock]'); if (clock) clock.textContent = entry.target.dataset.clock || ''; } }), { rootMargin: '-20% 0px -60% 0px' });
    all('[data-clock]', scope).forEach(section => chapterObserver.observe(section));
  }
  initialize(); document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
